<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { ClipboardPlus } from 'lucide-vue-next'
import type { Device } from '@/composables/useDevicesData'

defineProps<{
    device: Device
    selected: boolean
    expanded: boolean
    clipboardBusy?: boolean
}>()

const emit = defineEmits<{
    (e: 'toggle-select'): void
    (e: 'toggle-expand'): void
    (e: 'add-to-clipboard'): void
}>()

const { t } = useI18n()

function onClipboardClick(ev: MouseEvent) {
    ev.stopPropagation()
    emit('add-to-clipboard')
}
</script>

<template>
    <article
        class="bg-white border border-gray-200 rounded-12 p-3 flex flex-col gap-2 transition"
        :class="{ 'ring-2 ring-teal': selected, 'border-teal': expanded }"
    >
        <div class="flex items-start gap-2">
            <!--
                Checkbox handles selection. .stop on click prevents the
                surrounding card's expand-toggle from firing.
            -->
            <input
                type="checkbox"
                :checked="selected"
                class="mt-1 w-5 h-5 accent-teal cursor-pointer shrink-0"
                @click.stop="$emit('toggle-select')"
            />
            <button
                type="button"
                class="flex-1 min-w-0 text-left"
                @click="$emit('toggle-expand')"
            >
                <div class="font-semibold text-ink truncate">{{ device.name }}</div>
                <div class="mt-0.5 text-xs text-gray-500 font-mono truncate">@{{ device.username }}</div>
            </button>
            <button
                type="button"
                class="text-gray-500 hover:text-teal transition-colors shrink-0 p-1 disabled:opacity-40 disabled:cursor-wait"
                :title="t('devices.qr.addToClipboard')"
                :disabled="clipboardBusy"
                @click="onClipboardClick"
            >
                <ClipboardPlus class="w-4 h-4" />
            </button>
        </div>
    </article>
</template>
